import React, { FC } from 'react';
import { TypeBadgeFields } from '@/core/generated-types';
import { TW_BADGE_COLORS } from '@/core/constants';

export interface TypeBadgeProps extends TypeBadgeFields {
  classes?: string;
  onRemove?: () => void;
}
const Badge: FC<TypeBadgeProps> = (fields) => {
  const { badgeColor = 'Indigo', text, classes = '', onRemove } = fields;
  const { bg, textColor } = TW_BADGE_COLORS[badgeColor];

  return (
    <div
      data-testid="badge"
      className={`badge badge-md rounded-3xl md:badge-lg ${bg} !h-auto px-4 py-1 !text-sm ${textColor} whitespace-nowrap font-bold ${classes}`}
    >
      {text}
      {onRemove && (
        <button
          className="flex items-center justify-center flex-shrink-0 pl-4"
          aria-label={`Remove ${text} badge`}
          onClick={onRemove}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            className="text-white"
          >
            <path
              d="M11 3L3 11M3 3l8 8"
              stroke="currentColor"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default React.memo(Badge);
